import { Dialog, Button, DialogActions, DialogTitle } from '@mui/material'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { logout } from '~/account/model/actions'
import { ReduxState } from '~/redux/createRootReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoggedInWithBusinessAccountDialogComponent = (props: any) => {
  // eslint-disable-next-line react/destructuring-assignment
  const visible = props.loggedInWithBusinessAccount
  // eslint-disable-next-line react/destructuring-assignment
  const logoutAction = props.logout
  const { t } = useTranslation()

  return (
    <Dialog id="logged-in-with-business-account-dialog" open={visible} maxWidth="sm">
      <DialogTitle>{t('logged_in_with_business_account_title')}</DialogTitle>

      {t('logged_in_with_business_account_text')}

      <DialogActions>
        <Button data-test="logout-button" color="secondary" onClick={logoutAction}>
          {t('logged_in_with_business_account_logout')}
        </Button>
        <Button data-test="go-to-business-button" color="primary" href="/business">
          {t('logged_in_with_business_account_go_to_business')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const LoggedInWithBusinessAccountDialog = connect(
  (state: ReduxState) => ({
    ...state.account,
  }),
  { logout }
)(LoggedInWithBusinessAccountDialogComponent)
